export const WEIGHT = 'weight';
export const WEIGHTUNIT = 'weightUnit';
export const LENGTH = 'length';
export const WIDTH = 'width';
export const HEIGHT = 'height';
export const DIMENSIONUNIT = 'dimensionUnit';
export const QUANTITY = 'quantity';
export const WEIGHTUNITKG = 'KG';
export const WEIGHTUNITLB = 'LB';

export const ISDRYICESHIPMENT = 'IsDryIceShipment';
export const DRYICEWEIGHT = 'DryIceWeight';
export const DRYICEWEIGHTUNIT = 'DryIceWeightUnit';
export const ISRETURNSHIPMENTOPTED = 'IsReturnShipmentOpted';
export const SERVICEOPTION = 'ServiceOption';
export const CARRIERSERVICECODE = 'CarrierServiceCode';
export const ESTIMATEDPRICE = 'EstimatedPrice';
export const BILLINGCURRENCYCODE = 'BillingCurrencyCode';

export const COMPANY = 'company';
export const NAME = 'name';
export const PICKUPDATE = 'pickupdate';
export const EARLIESTPICKUPTIME = 'earliestPickupTime';
export const LATESTPICKUPTIME = 'latestpickuptime';
export const PICKUPCOMMENT = 'pickupComment';
export const PHONE = 'phone';
export const ISPICKUPREQUIRED = 'isPickUpRequired';

export const ADDRESS1 = 'address1';
export const ADDRESS2 = 'address2';
export const CITY = 'city';
export const STATE = 'state';
export const COUNTRY = 'country';
export const ZIPCODE = 'zipcode';
export const LB = 2.2;
export const KG = 0.45454545454545454;

export const DEFAULTCOUNTRY = 'US';

export const MAXDRYICEWEIGHT = { LB: '66', KG: '30' };

export const WEIGHT0 = 'weight0';
export const HEIGHT0 = 'height0';
export const LENGTH0 = 'length0';
export const WIDTH0 = 'width0';



